const FORWARDED_PARAMS = ['utm_source', 'utm_campaign', 'utm_content', 'utm_id', 'fbclid'] as const

/** Appends the current page's tracking params (UTMs + fbclid) to the given URL. */
export function withTrackingParams(url: string): string {
  if (typeof window === 'undefined') return url
  try {
    const pageParams = new URLSearchParams(window.location.search)
    const target = new URL(url)
    FORWARDED_PARAMS.forEach((key) => {
      const value = pageParams.get(key)
      if (value) target.searchParams.set(key, value)
    })
    return target.toString()
  } catch {
    return url
  }
}
